export default __webpack_public_path__ + "static/media/street-fighter-v.e93a8290.png";